import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from "@angular/common";
import {environment} from "@env/environment";
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class InitGoogleMapsService {

  constructor( @Inject(PLATFORM_ID) private platformId: any,
  private http: HttpClient) {}

  initGoogleMaps(apiKey:string) {
    if (isPlatformBrowser(this.platformId)) {
      return new Promise<void>((resolve) => {
        // Create a unique callback name to avoid conflicts
        const callbackName = 'initGoogleMapsCallback_' + Date.now();
        
        // Set up the global callback function
        (window as any)[callbackName] = () => {
          // Clean up the callback
          delete (window as any)[callbackName];
          resolve();
        };

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true; // Use async instead of defer for better performance
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places,geometry&loading=async&callback=${callbackName}`;
        script.onerror = () => {
          // Clean up the callback on error
          delete (window as any)[callbackName];
          console.error('Failed to load Google Maps API');
          resolve(); // Still resolve to prevent app from hanging
        };
        document.head.appendChild(script);

      });
    } else  {
      return new Promise<void>((resolve) => {
        resolve();
      });
    }

  }

  public initMap(): any  {
    if (!isPlatformBrowser(this.platformId)) return null;
    const mapContainer = document.getElementById('mapElement');
    const map = new google.maps.Map(mapContainer, {
      center: { lat: -34.397, lng: 150.644 },
      zoom: 8
    });
    return map;
  }

  getGeocode(address:string) {
    return this.http.get(
      'https://maps.googleapis.com/maps/api/geocode/json?' + `address=${address}&key=${environment.GOOGLE_MAP_API_KEY}`
    );
  }
}
